module.exports = __webpack_public_path__ + "static/media/MD.750e067c.svg";